import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import { useState } from "react";

import { useAppDispatch, useAppSelector } from "../../state/store";
import { fetchSernums, machineSerialNumberState, sendPassword, setMachineSerialNumber } from "../../state/sernums/sernums.slice";

export const VERSIONS = ["Version8", "Version9"];

interface TopControlProps {
  version: string;
  onVersionChange: (version: string) => void;
}

export function TopControl({ version, onVersionChange }: TopControlProps) {
  const dispatch = useAppDispatch();
  const machineSerialNumber = useAppSelector(machineSerialNumberState);

  const [password, setPassword] = useState("");
  const [textfieldValid, setTextfieldValid] = useState(false);
  const [isLoginEnabled, setIsPLoginEnabled] = useState(false); // New state for page enabled/disabled

  const handleClick = () => {
    if (!machineSerialNumber.trim()) return;

    // Create and append the full-page opacity div with "Processing..." text
    const opacityDiv = document.createElement("div");
    opacityDiv.style.position = "fixed";
    opacityDiv.style.top = "0";
    opacityDiv.style.left = "0";
    opacityDiv.style.width = "100%";
    opacityDiv.style.height = "100%";
    opacityDiv.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
    opacityDiv.style.zIndex = "1000";
    opacityDiv.style.display = "flex";
    opacityDiv.style.justifyContent = "center";
    opacityDiv.style.alignItems = "center";
    const processingText = document.createElement("span");
    processingText.textContent = "Processing...";
    processingText.style.color = "white";
    processingText.style.fontSize = "26px";
    opacityDiv.appendChild(processingText);
    document.body.appendChild(opacityDiv);

    dispatch(fetchSernums(machineSerialNumber))
      .unwrap()
      .then((payload) => {
        console.log("re", payload);
      })
      .finally(() => {
        // Remove the full-page opacity div
        document.body.removeChild(opacityDiv);
      });
  };

  const handlePasswordBtnClick = () => {
    dispatch(sendPassword(password))
      .unwrap()
      .then(() => {
        setTextfieldValid(true);
        setIsPLoginEnabled(true); // Enable the page on successful password verification
      })
      .catch((error) => {
        console.error("Password verification failed:", error);
        // Handle the error gracefully, e.g., show an error message to the user
        alert("Password verification failed. Please try again.");
      })
      .finally(() => {
        setPassword("");
      });
  };

  return (
    <Stack component={Card} direction="row" alignItems="center" sx={{ boxShadow: "none" }} padding={3} borderRadius={2.5} flexWrap="wrap" gap={4}>
      <Stack direction="row" alignItems="center" gap={2}>
        <Typography variant="subtitle2">Enter Service password: </Typography>
        <TextField
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter service password"
          inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 6 }}
        />
        <Button variant="contained" onClick={handlePasswordBtnClick}>
          Login
        </Button>
      </Stack>

      <Stack direction="row" alignItems="center" gap={2}>
        <Typography variant="subtitle2">Machine Serial Number: </Typography>
        <TextField
          placeholder="Serial number"
          disabled={!isLoginEnabled && process.env.REACT_APP_DEBUG === "False"}
          value={machineSerialNumber}
          onChange={(e) => dispatch(setMachineSerialNumber(e.target.value))}
          inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 6 }}
        />
        <Button variant="contained" onClick={handleClick} disabled={!isLoginEnabled && process.env.REACT_APP_DEBUG === "False"}>
          Load
        </Button>
        <TextField select size="small" label="Version" value={version} onChange={(e) => onVersionChange(e.target.value)} sx={{ minWidth: 140 }}>
          {VERSIONS.map((v) => (
            <MenuItem key={v} value={v}>
              {v}
            </MenuItem>
          ))}
        </TextField>
      </Stack>
    </Stack>
  );
}
